export const getCurrentRoute = (state) => state.location.type;
